/** Utility class for identifying local gids in Tiled and flipped flags
 * Reference: https://doc.mapeditor.org/en/stable/reference/global-tile-ids/#code-example
 */
export class TileUtility {
    public static readonly FLIPPED_HORIZONTAL = 0x80000000;
    public static readonly FLIPPED_VERTICAL = 0x40000000;
    public static readonly FLIPPED_DIAGONAL = 0x20000000;

    public static isTileFlippedX(gid: number): boolean {
        return gid > this.FLIPPED_HORIZONTAL;
    }

    public static isTileFlippedY(gid: number): boolean {
        return gid > this.FLIPPED_VERTICAL;
    }

    public static isTileFlippedDiag(gid: number): boolean {
        return gid > this.FLIPPED_DIAGONAL;
    }

    /**
     * Converts Tiled object gid to a local gid if it has an axis-flipping flag.
     * Reference: https://doc.mapeditor.org/en/stable/reference/global-tile-ids/#code-example
     */
    public static getLocalTiledGID(gid: number): number {
        if (this.isTileFlippedX(gid)) {
            gid -= this.FLIPPED_HORIZONTAL;
        }
        if (this.isTileFlippedY(gid)) {
            gid -= this.FLIPPED_VERTICAL;
        }
        if (this.isTileFlippedDiag(gid)) {
            gid -= this.FLIPPED_DIAGONAL;
        }
        return gid;
    }
}
